import React from "react";
import { OrganizationCategoryCard } from "./OrganizationCategoryCard";
import { OrganizationCategoryUIProvider } from "./OrganizationCategoryUIContext";

export function OrganizationCategoryPage({ history, match }) {
  const organizationCategoryUIEvents = {
    newOrganizationCategoryButtonClick: () => {
      history.push("/admin/master-data/category/create");
    },
    openEditOrganizationCategoryPage: id => {
      history.push(`/admin/master-data/category/${id}/edit`);
    }
  };

  return (
    <OrganizationCategoryUIProvider
      organizationCategoryUIEvents={organizationCategoryUIEvents}
    >
      <OrganizationCategoryCard history={history} match={match} />
    </OrganizationCategoryUIProvider>
  );
}
